"use strict";
/* eslint-disable object-curly-newline */

Object.defineProperty(exports, "__esModule", {
  value: true
}); // https://www.justice.gov/ust/eo/bapcpa/20210515/bci_data/median_income_table.htm

function getStateMedianFamilyIncome(dirtyState, persons) {
  if (!dirtyState) throw new Error("Missing State");
  var state = dirtyState.toUpperCase();
  if (!persons || persons === 0 || Number.isNaN(persons)) throw new Error("Missing Persons Count");
  var medianMap = {
    AK: {
      1: 64003,
      2: 86628,
      3: 103223,
      4: 103223
    },
    AL: {
      1: 49798,
      2: 60556,
      3: 67098,
      4: 81842
    },
    AR: {
      1: 46689,
      2: 58465,
      3: 67020,
      4: 68180
    },
    AZ: {
      1: 55839,
      2: 69975,
      3: 75560,
      4: 85714
    },
    CA: {
      1: 62938,
      2: 83435,
      3: 92735,
      4: 106530
    },
    CO: {
      1: 67768,
      2: 88178,
      3: 96223,
      4: 115473
    },
    CT: {
      1: 69244,
      2: 90286,
      3: 103544,
      4: 130975
    },
    DC: {
      1: 70934,
      2: 132134,
      3: 132134,
      4: 173898
    },
    DE: {
      1: 62152,
      2: 78813,
      3: 92496,
      4: 108527
    },
    FL: {
      1: 53182,
      2: 66748,
      3: 71689,
      4: 85203
    },
    GA: {
      1: 53105,
      2: 68295,
      3: 76391,
      4: 92286
    },
    GU: {
      1: 43298,
      2: 51770,
      3: 58994,
      4: 71390
    },
    HI: {
      1: 72396,
      2: 84224,
      3: 96021,
      4: 119681
    },
    IA: {
      1: 51725,
      2: 71767,
      3: 81910,
      4: 96373
    },
    ID: {
      1: 52477,
      2: 65730,
      3: 73196,
      4: 90767
    },
    IL: {
      1: 58698,
      2: 77547,
      3: 92711,
      4: 108549
    },
    IN: {
      1: 52327,
      2: 66386,
      3: 78113,
      4: 91772
    },
    KS: {
      1: 52598,
      2: 72442,
      3: 84404,
      4: 94036
    },
    KY: {
      1: 49646,
      2: 59017,
      3: 68293,
      4: 82626
    },
    LA: {
      1: 47488,
      2: 58303,
      3: 68168,
      4: 83547
    },
    MA: {
      1: 71708,
      2: 92034,
      3: 112146,
      4: 142040
    },
    MD: {
      1: 71839,
      2: 94405,
      3: 108879,
      4: 131859
    },
    ME: {
      1: 55354,
      2: 69713,
      3: 83145,
      4: 92782
    },
    MI: {
      1: 53815,
      2: 67015,
      3: 80465,
      4: 99179
    },
    MN: {
      1: 62574,
      2: 82483,
      3: 101669,
      4: 120110
    },
    MO: {
      1: 51144,
      2: 66490,
      3: 76431,
      4: 90521
    },
    MP: {
      1: 29076,
      2: 29076,
      3: 33828,
      4: 49754
    },
    MS: {
      1: 45317,
      2: 54584,
      3: 58459,
      4: 71528
    },
    MT: {
      1: 54870,
      2: 68613,
      3: 76078,
      4: 82969
    },
    NC: {
      1: 51278,
      2: 66859,
      3: 72958,
      4: 90039
    },
    ND: {
      1: 55701,
      2: 78927,
      3: 90689,
      4: 105279
    },
    NE: {
      1: 51474,
      2: 72321,
      3: 86989,
      4: 97943
    },
    NH: {
      1: 72047,
      2: 83344,
      3: 107942,
      4: 129738
    },
    NJ: {
      1: 71941,
      2: 88511,
      3: 112416,
      4: 134345
    },
    NM: {
      1: 47524,
      2: 58003,
      3: 63213,
      4: 67161
    },
    NV: {
      1: 54394,
      2: 69804,
      3: 77536,
      4: 84764
    },
    NY: {
      1: 60696,
      2: 77159,
      3: 92508,
      4: 112424
    },
    OH: {
      1: 52415,
      2: 67059,
      3: 79022,
      4: 96175
    },
    OK: {
      1: 49127,
      2: 63789,
      3: 68193,
      4: 79426
    },
    OR: {
      1: 62059,
      2: 74283,
      3: 89565,
      4: 101773
    },
    PA: {
      1: 57919,
      2: 71448,
      3: 88293,
      4: 105138
    },
    PR: {
      1: 24973,
      2: 24973,
      3: 27206,
      4: 32384
    },
    RI: {
      1: 64510,
      2: 80775,
      3: 96567,
      4: 109439
    },
    SC: {
      1: 49999,
      2: 64874,
      3: 71757,
      4: 86278
    },
    SD: {
      1: 52361,
      2: 71463,
      3: 83550,
      4: 92073
    },
    TN: {
      1: 50801,
      2: 63983,
      3: 72011,
      4: 86983
    },
    TX: {
      1: 52953,
      2: 71287,
      3: 77110,
      4: 89196
    },
    UT: {
      1: 67265,
      2: 73754,
      3: 86562,
      4: 96607
    },
    VA: {
      1: 64870,
      2: 82910,
      3: 98253,
      4: 116328
    },
    VI: {
      1: 34354,
      2: 41288,
      3: 44022,
      4: 48230
    },
    VT: {
      1: 56093,
      2: 74509,
      3: 88472,
      4: 112466
    },
    WA: {
      1: 71060,
      2: 86240,
      3: 99948,
      4: 113566
    },
    WI: {
      1: 55334,
      2: 73061,
      3: 88431,
      4: 104987
    },
    WV: {
      1: 50855,
      2: 55518,
      3: 68537,
      4: 74508
    },
    WY: {
      1: 57795,
      2: 72726,
      3: 84913,
      4: 101246
    }
  };
  return medianMap[state][persons > 4 ? 4 : persons] + (persons > 4 ? (persons - 4) * 9000 : 0);
}

exports.default = getStateMedianFamilyIncome; // Scraping helper script
// const states = {
//   AL: 'Alabama',
//   AK: 'Alaska',
//   AS: 'American Samoa',
//   AZ: 'Arizona',
//   AR: 'Arkansas',
//   CA: 'California',
//   CO: 'Colorado',
//   CT: 'Connecticut',
//   DE: 'Delaware',
//   DC: 'District Of Columbia',
//   FM: 'Federated States Of Micronesia',
//   FL: 'Florida',
//   GA: 'Georgia',
//   GU: 'Guam',
//   HI: 'Hawaii',
//   ID: 'Idaho',
//   IL: 'Illinois',
//   IN: 'Indiana',
//   IA: 'Iowa',
//   KS: 'Kansas',
//   KY: 'Kentucky',
//   LA: 'Louisiana',
//   ME: 'Maine',
//   MH: 'Marshall Islands',
//   MD: 'Maryland',
//   MA: 'Massachusetts',
//   MI: 'Michigan',
//   MN: 'Minnesota',
//   MS: 'Mississippi',
//   MO: 'Missouri',
//   MT: 'Montana',
//   NE: 'Nebraska',
//   NV: 'Nevada',
//   NH: 'New Hampshire',
//   NJ: 'New Jersey',
//   NM: 'New Mexico',
//   NY: 'New York',
//   NC: 'North Carolina',
//   ND: 'North Dakota',
//   MP: 'Northern Mariana Islands',
//   OH: 'Ohio',
//   OK: 'Oklahoma',
//   OR: 'Oregon',
//   PW: 'Palau',
//   PA: 'Pennsylvania',
//   PR: 'Puerto Rico',
//   RI: 'Rhode Island',
//   SC: 'South Carolina',
//   SD: 'South Dakota',
//   TN: 'Tennessee',
//   TX: 'Texas',
//   UT: 'Utah',
//   VT: 'Vermont',
//   VI: 'Virgin Islands',
//   VA: 'Virginia',
//   WA: 'Washington',
//   WV: 'West Virginia',
//   WI: 'Wisconsin',
//   WY: 'Wyoming',
// };
// function innerTextToNumber(str) {
//   return Number((str || '').replace(/[\D|,]/, '').replace(',', ''));
// }
// Array.from(document.querySelectorAll('table thead tr'))
//     .slice(3)
//     .map(r => ({
//       state: Object.keys(states).find(stKey => states[stKey] === Object.values(states).find(st => st.toUpperCase() === (r.querySelector('td:nth-of-type(1)') || {}).innerText)),
//       1: innerTextToNumber((r.querySelector('td:nth-of-type(2)') || {}).innerText),
//       2: innerTextToNumber((r.querySelector('td:nth-of-type(3)') || {}).innerText),
//       3: innerTextToNumber((r.querySelector('td:nth-of-type(4)') || {}).innerText),
//       4: innerTextToNumber((r.querySelector('td:nth-of-type(5)') || {}).innerText),
//     }))
//     .filter(obj => (obj.state || '').length)
//     .reduce((accum, obj) => ({
//       [obj.state]: {
//         1: obj[1],
//         2: obj[2],
//         3: obj[3],
//         4: obj[4],
//       },
//       ...accum,
//     }), {});